export default "__VITE_ASSET__CrxDF4AG__"